var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"res-card",class:_vm.active? 'active' : ''},[(_vm.appStatus === 0)?_c('tilt-card',{attrs:{"img":_vm.$t('home.card.res.imgRes'),"copy":_vm.copy,"notify_event":true},on:{"clicked":_vm.onRes}}):_vm._e(),(_vm.appStatus === 1)?_c('tilt-card-resed'):_vm._e(),(_vm.appStatus === 2)?_c('tilt-card-checkin'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }